import { render, staticRenderFns } from "./OverviewPeriodBar.vue?vue&type=template&id=584b591b&"
import script from "./OverviewPeriodBar.vue?vue&type=script&lang=js&"
export * from "./OverviewPeriodBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports